import { Card, Title, Text } from '@tremor/react';
import { NAV_ITEMS } from '@/components/Layout';
import { useRouterState } from '@tanstack/react-router';

export function PlaceholderPage() {
  const router = useRouterState();
  const path = router.location.pathname;
  const item = NAV_ITEMS.find((i) => i.to === path);

  const phase = item?.phase ?? 1;
  const label = item?.label ?? 'Em construção';

  return (
    <div className="mx-auto max-w-2xl space-y-4">
      <Title>{label}</Title>
      <Text>
        Esta página será entregue na Phase {phase}. Ainda não há nada para mostrar
        aqui.
      </Text>
      <Card className="border border-dashed border-slate-700 bg-slate-900/40">
        <div className="space-y-2 text-sm">
          <p className="text-slate-200">
            <strong>Phase {phase}</strong> — em breve.
          </p>
          <ul className="list-inside list-disc text-slate-400">
            <li>Backend endpoints a definir.</li>
            <li>Frontend componente a definir.</li>
            <li>Pull request separado por página.</li>
          </ul>
        </div>
      </Card>
    </div>
  );
}
